
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { ScheduleCommandRequest, ScheduleCommandResponse } from './types';
import { axiosInstance } from "../axios-instance";

class ShortCommandV2 {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueScheduleCommand(
        input: ScheduleCommandRequest,
    ): Promise<AxiosResponse<ScheduleCommandResponse>> {
        const accessToken = localStorage.getItem('accessToken');
        return axiosInstance.post<ScheduleCommandResponse>(`${this.baseUrl}/scheduleCommands`, input, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }

    getScheduleCommands(): Promise<AxiosResponse<any>> {
        const accessToken = localStorage.getItem('accessToken');
        return axiosInstance.get<any>(`${this.baseUrl}/scheduleCommands`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        });
    }
   
}

export default ShortCommandV2;